import { render, staticRenderFns } from "./DiscountCodes.vue?vue&type=template&id=35823b7a&"
import script from "./DiscountCodes.vue?vue&type=script&lang=js&"
export * from "./DiscountCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports